export default '1.10.3';



// WEBPACK FOOTER //
// ./src/lib/version.js